import {clsx} from 'clsx'
import {type ReactNode, useId} from 'react'

import {LabelIdProvider} from '../LabelIdContext'
import styles from './SimpleListViewContainer.module.css'

interface SimpleListViewContainerProps {
  ['data-testid']?: string
  children: ReactNode
  className?: string
}

const SimpleListViewContainer = ({children, className, ...props}: SimpleListViewContainerProps) => {
  const labelId = useId()

  return (
    <LabelIdProvider value={labelId}>
      <div className={clsx(styles.container, className)} {...props}>
        {children}
      </div>
    </LabelIdProvider>
  )
}

export default SimpleListViewContainer

try{ SimpleListViewContainer.displayName ||= 'SimpleListViewContainer' } catch {}